import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Layout, DatePicker, Select, Space } from 'antd';
import { UserOutlined, LockOutlined, PhoneOutlined, MailOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import '../styles/Login.css';

const { Title } = Typography;
const { Content } = Layout;
const { Option } = Select;

const Register = () => {
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    const success = await register(values);
    setLoading(false);
    
    if (success) {
      navigate('/');
    }
  };

  return (
    <Layout className="login-layout">
      <Content className="login-content">
        <div className="login-logo">
          <h1 style={{ fontSize: '24px', color: '#8d6e63' }}>千方智能问诊系统</h1>
        </div>
        
        <Card className="login-card" style={{ maxWidth: '500px' }}>
          <Title level={2} className="login-title">注册账号</Title>
          
          <Form
            name="register"
            initialValues={{ gender: '男' }}
            onFinish={onFinish}
            layout="vertical"
          >
            <Form.Item
              name="name"
              rules={[{ required: true, message: '请输入姓名' }]}
            >
              <Input prefix={<UserOutlined />} placeholder="姓名" />
            </Form.Item>

            <Form.Item
              name="phone"
              rules={[
                { required: true, message: '请输入手机号码' },
                { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号码' }
              ]}
            >
              <Input prefix={<PhoneOutlined />} placeholder="手机号码" />
            </Form.Item>

            <Form.Item
              name="email"
              rules={[
                { type: 'email', message: '请输入有效的邮箱地址' }
              ]}
            >
              <Input prefix={<MailOutlined />} placeholder="邮箱（选填）" />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                { required: true, message: '请输入密码' },
                { min: 6, message: '密码长度不能少于6个字符' }
              ]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="密码" />
            </Form.Item>

            <Form.Item
              name="confirmPassword"
              dependencies={['password']}
              rules={[
                { required: true, message: '请确认密码' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('两次输入的密码不一致'));
                  },
                }),
              ]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="确认密码" />
            </Form.Item>

            <Space size={16} style={{ display: 'flex' }}>
              <Form.Item
                name="gender"
                style={{ marginBottom: 0, flex: 1 }}
              >
                <Select placeholder="性别">
                  <Option value="男">男</Option>
                  <Option value="女">女</Option>
                </Select>
              </Form.Item>

              <Form.Item
                name="birthdate"
                style={{ marginBottom: 0, flex: 2 }}
              >
                <DatePicker placeholder="出生日期" style={{ width: '100%' }} />
              </Form.Item>
            </Space>

            <Form.Item style={{ marginTop: 16 }}>
              <Button type="primary" htmlType="submit" className="login-button" loading={loading}>
                注册
              </Button>
            </Form.Item>
            
            <div style={{ textAlign: 'center' }}>
              已有账号？ <Link to="/login">立即登录</Link>
            </div>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
};

export default Register; 